module.exports = __webpack_public_path__ + "bd09ee17b24baacc93b68ca986694a6e.svg";